import { Routes } from '@angular/router';

import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { AuthGuard } from './core/guards/auth.guard';
import { AdminComponent } from './pages/admin/admin.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { RoleGuard } from './core/guards/role.guard';
import { AppConstants } from './app.constants';
import { NotFoundErrorPageComponent } from './misc/error-pages/not-found.component';
import { ForbiddenErrorPageComponent } from './misc/error-pages/forbidden.component';
import { DashboardOutletComponent } from './pages/dashboard-outlet/dashboard-outlet.component';
import { LoginComponent } from './pages/login/login.component';
import { LoginGuard } from './core/guards/login.guard';
import { PdfAssignerComponent } from './pages/pdf-assigner/pdf-assigner.component';
import { PdfAssignerDialogMessagesEnum } from './core/enums/toastr-messages/pdf-assigner.dialog-messages.enum';
import { FeatureRestrictionGuard } from './core/guards/feature-restriction.guard';
import { FullScreenComponent } from './components/full-screen/full-screen.component';

export const AppRoutes: Routes = [
  {
    path: '',
    component: DashboardOutletComponent,
    canActivate: [AuthGuard],
    title: AppConstants.DDS_PAGE_TITLE,
    children: [
      {
        path: '',
        component: DashboardComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRoles: [AppConstants.ADMINISTRATOR_ROLE, AppConstants.EDITOR_ROLE, AppConstants.CATEGORY_MANAGER_ROLE],
          possibleRole: AppConstants.PDF_ASSIGNER_ROLE
        },
        pathMatch: 'full',
      },
      {
        path: 'Admin',
        component: AdminComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRoles: [AppConstants.ADMINISTRATOR_ROLE, AppConstants.CATEGORY_MANAGER_ROLE]
        },
        children: [
          {
            path: '',
            loadChildren: () => import('./admin-module/admin.module').then(m => m.AdminModule)
          },
        ],
      },
      {
        path: 'PdfAssigner',
        component: PdfAssignerComponent,
        canActivate: [RoleGuard, FeatureRestrictionGuard],
        data: {
          expectedRoles: [AppConstants.ADMINISTRATOR_ROLE, AppConstants.PDF_ASSIGNER_ROLE],
          featureName: AppConstants.PDF_FILE_TYPE,
          isAllowedByTrialMode: false,
          errorMessage: PdfAssignerDialogMessagesEnum.LicensePermissionDeniedTitle
        },
        children: [
          {
            path: '',
            loadChildren: () => import('./pdf-assigner-module/pdf-assigner.module').then(m => m.PdfAssignerModule),
          },
        ],
      },
      {
        path: 'Profile',
        component: ProfileComponent,
        children: [
          {
            path: '',
            loadChildren: () => import('./profile-module/profile.module').then(m => m.ProfileModule)
          },
        ],
      }
    ],
  },
  {
    path: 'Account',
    component: LoginComponent,
    canActivate: [LoginGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./login-module/login.module').then(m => m.LoginModule)
      },
    ],
    title: AppConstants.DDS_SIGN_IN_PAGE_TITLE
  },
  {
    path: 'NotFound',
    component: NotFoundErrorPageComponent,
    pathMatch: 'full',
  },
  {
    path: 'Forbidden',
    component: ForbiddenErrorPageComponent,
    pathMatch: 'full',
  },
  {
    path: AppConstants.FULL_SCREEN_PATH,
    component: FullScreenComponent,
  },
  { path: '**', redirectTo: 'NotFound' },
];
